var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 56,
    viewBox: "0 0 44 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9487 9.92774C42.5435 8.96997 41.8697 8.15994 41.0213 7.58535C40.1725 7.01234 39.1392 6.67457 38.0403 6.67457H33.4528V5.88314H26.8036C26.834 5.66807 26.8508 5.44621 26.8508 5.22273C26.8506 2.60136 24.7184 0.468994 22.0969 0.468994C19.4755 0.468994 17.3432 2.60136 17.3432 5.22273C17.3432 5.44621 17.36 5.66807 17.3903 5.88314H10.7411V6.67457H6.15364C5.42267 6.67457 4.71697 6.82416 4.0801 7.09463C3.1206 7.49962 2.31069 8.1734 1.73598 9.02202C1.16299 9.87225 0.825195 10.904 0.825195 12.003V50.2043C0.825195 50.9353 0.974788 51.6395 1.24365 52.2779C1.65027 53.2358 2.32413 54.0456 3.17275 54.6202C4.02139 55.1951 5.05465 55.5311 6.15364 55.5311H38.0403L43.3688 32.5095V12.003C43.3688 11.2704 43.219 10.5663 42.9487 9.92774ZM22.0969 3.45837C23.0699 3.45837 23.8613 4.24979 23.8613 5.22273C23.8613 5.45632 23.8142 5.67806 23.7302 5.88314H20.4618C20.3795 5.67818 20.3324 5.45632 20.3324 5.22273C20.3326 4.24979 21.1257 3.45837 22.0969 3.45837ZM38.0403 52.362H6.15364C5.85111 52.362 5.57053 52.3014 5.3134 52.1939C4.92861 52.0309 4.59588 51.7537 4.3623 51.4091C4.12871 51.063 3.99428 50.6562 3.99428 50.2043V12.003C3.99428 11.7005 4.05483 11.4199 4.16398 11.1628C4.32703 10.7763 4.60094 10.4452 4.947 10.2117C5.29318 9.97979 5.69981 9.84536 6.15352 9.84365H10.7409V10.5041C10.7409 11.7442 11.7458 12.749 12.9876 12.749H31.206C32.4479 12.749 33.4528 11.7442 33.4528 10.5041V9.84365H38.0401C38.3427 9.84365 38.6232 9.9042 38.8802 10.0133C39.2652 10.1764 39.5979 10.4503 39.8315 10.7964C40.0634 11.1442 40.1977 11.5492 40.1994 12.0029V21.5533V32.5095H43.3688L38.0403 55.5311V52.362Z",
    fill: "#001B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2559 42.4612V45.1028H43.3688V42.4612H29.2559Z",
    fill: "#001B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2165 18.5057H9.41626V21.1456H29.2165V18.5057Z",
    fill: "#001B4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2165 25.769H9.41626V28.4089H29.2165V25.769Z",
    fill: "#001B4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2165 33.031H9.41626V35.6709H29.2165V33.031Z",
    fill: "#001B4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3997 40.2355H9.50024V42.877H19.3997V40.2355Z",
    fill: "#001B4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4503 35.595H35.1738V51.9712H37.4503V35.595Z",
    fill: "#001B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.50473ba75e5134c3d9c153f70c25dc79.svg";
export { ForwardRef as ReactComponent };